import { ISentFaxInboxModel } from "../UI/ISentFaxInboxModel";

class SentFaxSearchSettings {
    public ShowAllClinicians: boolean;
    public ShowAllStatuses: boolean;
    public ShowAllSites: boolean;
    public SelectedPageSizeOption: number;
    public ShowOnlySelectedSites: boolean;
    public IncludeIgnored: boolean;
    public ClinicianIds: string[];
    public SiteIds: string[];
    public Statuses: string[];

    public constructor(init?: Partial<SentFaxSearchSettings>) {
        Object.assign(this, init);
    }

    public static fromModel(model: ISentFaxInboxModel): SentFaxSearchSettings {
        const helper = cacheStore.Helper;

        return new SentFaxSearchSettings({
            ShowAllClinicians: model.get("SelectAllCliniciansChecked"),
            ShowAllSites: model.get("SelectAllSitesChecked"),
            ShowAllStatuses: model.get("SelectAllStatusChecked"),
            SelectedPageSizeOption: model.get("SelectedPageSizeOption"),
            ShowOnlySelectedSites: model.get("ShowOnlySelectedSites"),
            IncludeIgnored: model.get("IncludeIgnored"),

            ClinicianIds: helper.GetCheckedItemsFromICheckableList(model.get("CliniciansFiltered"))?.map(p => p.Id).toArray(),
            SiteIds: helper.GetCheckedItemsFromICheckableList(model.get("Sites"))?.map(p => p.Id).toArray(),
            Statuses: helper.GetCheckedItemsFromICheckableList(model.get("Status"))?.map(p => p.Id).toArray()
        });
    }
}

export { SentFaxSearchSettings };
